/**
 * Shared utilities + constants for the BrandAssetGallery module.
 *
 * Extracted from the monolithic BrandAssetGallery.jsx during the
 * May 2026 component refactor. No logic changes — pure relocation.
 */

const _API_BASE =
  typeof window !== "undefined" && window.location.hostname !== "localhost"
    ? window.location.origin
    : process.env.REACT_APP_BACKEND_URL ||
      (typeof window !== "undefined" ? window.location.origin : "");
export const API = `${_API_BASE}/api`;

export const ORIGINS = ["real", "ai_generated", "stock", "designer", "unknown"];
export const POOLS = [
  "subjects", "logos", "fonts", "decorations",
  "backgrounds", "illustrations", "lockups",
];
export const PAGE_SIZE = 48;

// ─── Phase 1.4 verdict / publication taxonomy ───────────────────────────
export const VERDICTS = [
  { key: "safe",      label: "Safe",   color: "bg-emerald-500", textColor: "text-emerald-700", ringColor: "ring-emerald-300", lightBg: "bg-emerald-50" },
  { key: "ambiguous", label: "Review", color: "bg-amber-500",   textColor: "text-amber-700",   ringColor: "ring-amber-300",   lightBg: "bg-amber-50" },
  { key: "unsafe",    label: "Unsafe", color: "bg-rose-500",    textColor: "text-rose-700",    ringColor: "ring-rose-300",    lightBg: "bg-rose-50" },
];
const VERDICT_LOOKUP = VERDICTS.reduce((m, v) => ({ ...m, [v.key]: v }), {});
export const PUBLICATION_STATUSES = [
  { key: "unrestricted",  label: "Unrestricted" },
  { key: "public",        label: "Public only" },
  { key: "internal_only", label: "Internal only" },
];

export function verdictMeta(verdict) {
  return VERDICT_LOOKUP[verdict] || {
    key: "unclassified",
    label: "Unclassified",
    color: "bg-slate-300",
    textColor: "text-slate-600",
    ringColor: "ring-slate-300",
    lightBg: "bg-slate-50",
  };
}

// Format helper for the triage banner: 308.5 min → "5h 9m"
export function fmtMins(mins) {
  if (!Number.isFinite(mins) || mins <= 0) return "0 min";
  if (mins < 60) return `${Math.round(mins)} min`;
  const h = Math.floor(mins / 60);
  const m = Math.round(mins - h * 60);
  return m ? `${h}h ${m}m` : `${h}h`;
}

export function authedFetch(url, options = {}) {
  return fetch(url, { credentials: "include", ...options });
}

export function shortFolder(path) {
  if (!path) return "(unknown)";
  const parts = path.split("/").filter(Boolean);
  return parts.slice(-2).join(" / ") || path;
}
